module.exports = __webpack_public_path__ + "img/redwulf-200A.a6c4f9d8.png";